<template>
  <div class="popup-container">
    <div class="masking"></div>
    <div class="modal" :style="`width:${width};min-height:${height}`">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  props:{
    width:{
      type:String,
      default:'300px'
    },
    height:{
      type:String,
      default:'400px'
    }
  },
  methods:{
    close(){
      this.$emit('close')
    }
  },
  data(){
    return{

    }
  }
}
</script>
<style lang="scss" scoped>
.popup-container{
  width: 100%;
    position: fixed;
    height: 100%;
    left: 0;
    top: 0;
    border-radius: 8px;
    overflow: hidden;
    padding-bottom: 20px;
  .masking{

  }
  .modal{
  //  padding-bottom: 20px;
  }
 
}
</style>


// WEBPACK FOOTER //
// src/components/plugins/popup.vue